export default __webpack_public_path__ + "static/media/logoleve.84181028.svg";